import { root } from '../store/constants';
import React from 'react';

export const openKanbanchiLink = (e: MouseEvent | React.MouseEvent)  => {
    const target = e.target as HTMLAnchorElement;
    const linkBoard = target.href.match(/d-\d{16}/);
    if (!linkBoard || !linkBoard.length) return;
    //@ts-ignore
    const isLinkCurrentBoard = window.location.href.includes(linkBoard[0]);
    if (isLinkCurrentBoard && root.App.router.openLink(target.href)) {
        e.preventDefault();
    }
};
